// extracted by mini-css-extract-plugin
export default {"reuploadImageButtonWrap":"ReuploadImageButton_reuploadImageButtonWrap__0a-Ga","reuploadImageButton":"ReuploadImageButton_reuploadImageButton__1uCSx"};